// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container____0B71 {
    position: fixed;
    bottom: 0;
    right: 40vw;
    width: 20vw;
    background-color: #fefefe;
    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.15);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 12px;
}

.style__buttonsContainer___t2hmE {
    display: flex;
    flex-direction: row;
    margin-top: 12px;
    justify-content: center;
    align-items: center;
}

.style__button___hF3Wi {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5vw;
    font-size: 15px;
    border-radius: 40px;
    height: 32px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 16px;
    text-align: center;
    color: var(--black);
}

.style__cancel___cH6iI {
    border: 1px solid red;
    color: red
}

.style__confirm___Yjjfh {
    border: 1px solid var(--primary-color);
    color: var(--primary-color)
}
`, "",{"version":3,"sources":["webpack://./src/components/MovingFileView/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,2CAA2C;IAC3C,4BAA4B;IAC5B,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,sCAAsC;IACtC;AACJ","sourcesContent":[".container {\n    position: fixed;\n    bottom: 0;\n    right: 40vw;\n    width: 20vw;\n    background-color: #fefefe;\n    box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.15);\n    border-top-left-radius: 20px;\n    border-top-right-radius: 20px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding-top: 12px;\n}\n\n.buttonsContainer {\n    display: flex;\n    flex-direction: row;\n    margin-top: 12px;\n    justify-content: center;\n    align-items: center;\n}\n\n.button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 5vw;\n    font-size: 15px;\n    border-radius: 40px;\n    height: 32px;\n    margin-left: 20px;\n    margin-right: 20px;\n    margin-bottom: 16px;\n    text-align: center;\n    color: var(--black);\n}\n\n.cancel {\n    border: 1px solid red;\n    color: red\n}\n\n.confirm {\n    border: 1px solid var(--primary-color);\n    color: var(--primary-color)\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container____0B71`,
	"buttonsContainer": `style__buttonsContainer___t2hmE`,
	"button": `style__button___hF3Wi`,
	"cancel": `style__cancel___cH6iI`,
	"confirm": `style__confirm___Yjjfh`
};
export default ___CSS_LOADER_EXPORT___;
